import { Link,NavLink } from "react-router-dom"
import Logo from "../assets/FITA_logo.png"
import { getUserPermission } from "../services/helpers";


function handleSignOut(){
	localStorage.removeItem("token");
}


export function Header(){
	return (
		<>
			<header>

				<div id="logo-section">
					<img src={Logo} alt="FITA logo" />
				</div>

				<div id="navlinks">
					{/* <Link>Admin</Link>
					<Link>Security</Link> */}
					{/* <Link
					className={({ isActive }) => isActive ? "active-subnav" : ""}
					 to="salesdashboard"
					 >Sales Report</Link> */}
					<NavLink
					className={({ isActive }) => isActive ? "active-subnav" : ""}
					 to="/dashboard/roadworthy"
					 >License and Roadworthy</NavLink>
					<NavLink
					className={({ isActive }) => isActive ? "active-subnav" : ""}
					 to="subscriptions"
					 >Membership Plans</NavLink>
					{getUserPermission !== "basic" && <NavLink
						to="/dashboard/buddies"
					 className={({ isActive }) => isActive ? "active-subnav" : ""}
					>Buddies</NavLink>}
					{getUserPermission !== "basic" && <NavLink
						to="/dashboard/admin-emails"
					 className={({ isActive }) => isActive ? "active-subnav" : ""}
					>Admin Emails</NavLink>}
				</div>

				<div id="action-section">
					<Link className="red-text" to="/" onClick={handleSignOut}>Sign Out</Link>
				</div>

			</header>

		</>
	)
}